import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LanguageService } from 'src/app/services/language.service';
import { ListFields } from '../../listfields';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

@Component({
  selector: 'app-multiple-search',
  templateUrl: './multiple-search.component.html',
  styleUrl: './multiple-search.component.scss',
  standalone: false
})
export class MultipleSearchComponent {

  @Input() searchFields: ListFields[] = [];
  @Input() searchByList: any = {};
  @Output() searchByListChange = new EventEmitter();

  public selectedSearchField: number = 0;
  public searchText: string = "";
  public booleanValue: string = "";
  public picker1: any;
  public picker2: any;
  public startDate: Date | null = null;
  public endDate: Date | null = null;
  public maxDate: Date = new Date();

  constructor(public languageService: LanguageService) {

  }

  public applySearchFilter() {
    if (this.getDateInterval()) {
      if (this.startDate != null && this.endDate != null) {
        this.searchByList[this.getFieldName()] = this.getDateString(this.startDate) + " - " + this.getDateString(this.endDate);
        this.searchByListChange.emit({ ...this.searchByList });
      }
    }
    else if (this.getBooleanSelector()) {
      this.searchByList[this.getFieldName()] = this.booleanValue;
      this.searchByListChange.emit({ ...this.searchByList });
    }
    else if (this.searchText != "") {
      this.searchByList[this.getFieldName()] = this.searchText;
      this.searchByListChange.emit({ ...this.searchByList });
    }
  }

  private getDateString(date: Date): string {
    const offset = date.getTimezoneOffset();
    return new Date(date.getTime() - (offset * 60 * 1000)).toISOString().split('T')[0].replaceAll("-", "/");
  }

  public onStartDateChange(event: MatDatepickerInputEvent<Date>) {
    this.startDate = event.value;
  }

  public onEndDateChange(event: MatDatepickerInputEvent<Date>) {
    this.endDate = event.value;
  }

  private getFieldName(): string {
    return this.searchFields.find((el) => { return el.Id == this.selectedSearchField })?.FieldName || "";
  }

  public getDateInterval(): boolean {
    return this.searchFields.find((el) => { return el.Id == this.selectedSearchField })?.DateInterval || false;
  }

  public getBooleanSelector(): boolean{
    return this.searchFields.find((el) => { return el.Id == this.selectedSearchField })?.BooleanSelector || false;
  }
}
